import React from 'react';
import { Section } from './ui/Section';
export function PromiseSection() {
  return <Section background="accent" className="text-center" data-id="element-160">
      <h2 className="text-2xl md:text-3xl font-serif font-bold text-white mb-6" data-id="element-161">
        La promesa correcta (sin exagerar)
      </h2>
      <p className="text-xl text-indigo-100 max-w-2xl mx-auto leading-relaxed" data-id="element-162">
        No te prometo una vida perfecta. <br data-id="element-163" />
        Te prometo algo mejor: <br data-id="element-164" />
        <strong className="text-white block mt-4 text-2xl" data-id="element-165">
          un sistema que te ayuda a recuperar continuidad
        </strong>
        <span className="block mt-2 text-base opacity-80" data-id="element-166">
          y a reducir el costo emocional de cada despertar.
        </span>
      </p>
    </Section>;
}